var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dc4391;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My_Account_-_Profile",
    "data-name": "My Account - Profile"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.171,16.209a1.258,1.258,0,0,0-.5.091L11.974,23.486a1.254,1.254,0,0,0-.044,2.307L17.4,28.255l-.173,9.026a4.06,4.06,0,0,0,1.261,2.865,9.351,9.351,0,0,0,2.867,1.911,22.807,22.807,0,0,0,16.638.317,9.312,9.312,0,0,0,2.936-1.8,4.057,4.057,0,0,0,1.37-2.815l.172-9.026,1.264-.512L43.7,30.262a1.254,1.254,0,1,0,2.506.082v-.035l.059-3.112,1.763-.719a1.254,1.254,0,0,0,.044-2.306L30.664,16.315a1.265,1.265,0,0,0-.493-.106Zm-.05,2.618,14.247,6.431L29.886,31.142,15.639,24.71ZM19.887,29.381l9.457,4.268a1.25,1.25,0,0,0,.989.019l9.611-3.9-.152,7.947a1.539,1.539,0,0,1-.595,1.052,7.142,7.142,0,0,1-2.157,1.292A20.3,20.3,0,0,1,22.4,39.776,7.165,7.165,0,0,1,20.293,38.4a1.541,1.541,0,0,1-.557-1.076Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.b6c38ee38cfb60d4503d13eceff327e8.svg";
export { ForwardRef as ReactComponent };